import { DataType } from './DataType';
import { RoleType, VariableType } from './Field';
import { BField, FieldType } from './Field';
export var SystemFieldName;
(function (SystemFieldName) {
    SystemFieldName["NAMES"] = "$NAMES";
    SystemFieldName["VALUES"] = "$VALUES";
    SystemFieldName["MULTIPLE"] = "$MULTIPLE";
})(SystemFieldName || (SystemFieldName = {}));
export class SystemField extends BField {
    constructor(systemFieldName) {
        super();
        this._systemFieldName = systemFieldName;
    }
    get name() {
        if (this.isNames) {
            return 'Measure Names';
        }
        else if (this.isValues) {
            return 'Measure Values';
        }
        else if (this.isMultiple) {
            return 'Multiple Fields';
        }
    }
    get systemFieldName() {
        return this._systemFieldName;
    }
    get dataType() {
        if (this.isNames) {
            return DataType.STRING;
        }
        else if (this.isValues) {
            return DataType.NUMBER;
        }
    }
    get roleType() {
        if (this.isNames) {
            return RoleType.DIMENSION;
        }
        else if (this.isValues) {
            return RoleType.MEASURE;
        }
    }
    get varType() {
        if (this.isNames) {
            return VariableType.DISCRETE;
        }
        else if (this.isValues) {
            return VariableType.CONTINUOUS;
        }
    }
    get isNames() {
        return this.type === FieldType.MODELNAMES || this.type === FieldType.VIEWNAMES;
    }
    get isValues() {
        return this.type === FieldType.MODELVALUES || this.type === FieldType.VIEWVALUES;
    }
}
export class ModelSystemField extends SystemField {
    constructor(systemFieldName) {
        super(systemFieldName);
        switch (systemFieldName) {
            case SystemFieldName.NAMES:
                this._type = FieldType.MODELNAMES;
                break;
            case SystemFieldName.VALUES:
                this._type = FieldType.MODELVALUES;
                break;
            case SystemFieldName.MULTIPLE:
                this._type = FieldType.MODELMULTIPLE;
                break;
        }
    }
    get type() {
        return this._type;
    }
    get isMultiple() {
        return this.type === FieldType.MODELMULTIPLE;
    }
}
export class ViewSystemField extends SystemField {
    constructor(systemFieldName, id, sid) {
        super(systemFieldName);
        this._id = id;
        this._sid = sid || 0;
        switch (systemFieldName) {
            case SystemFieldName.NAMES:
                this._type = FieldType.VIEWNAMES;
                break;
            case SystemFieldName.VALUES:
                this._type = FieldType.VIEWVALUES;
                break;
        }
    }
    get id() {
        return this._id;
    }
    get sid() {
        return this._sid;
    }
    get psid() {
        return `00${this.sid}`.slice(-2);
    }
    get alias() {
        if (this.sid) {
            return `f-${this.psid}-${this.id}`;
        }
        else {
            return this.id;
        }
    }
    get source() {
        return this.systemFieldName;
    }
    get type() {
        return this._type;
    }
}
